import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil, DateHandler } from 'utils'

const PlazoDiasFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  index,
  handleBlur,
  values,
  actualizarFilaHandler,
  setFieldValue,
  fechaEmisionDocumento
}) => {
  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`input-monto-cuota-${index}`, e)
    },
    [index]
  )

  const innerHandleBlur = React.useCallback(
    e => {
      handleBlur(e)

      const nuevaFecha = DateHandler.add(DateHandler.parse(fechaEmisionDocumento), { days: values.plazoDias })
      const fecha = DateHandler.format(nuevaFecha)

      setFieldValue('fecha', fecha)

      actualizarFilaHandler({ index: index, rowData: { ...values, fecha } })
    },
    [handleBlur, index, values, actualizarFilaHandler, setFieldValue, fechaEmisionDocumento]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='plazoDias'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id={`input-plazoDias-cuota-${index}`}
              onBlur={innerHandleBlur}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlazoDiasFormGroup)
